import "vite/modulepreload-polyfill"; // backend integration (no index.html): makes <link rel=modulepreload> work
import "../scss/application.scss"; // site-wide styles → application.css

// AIRC site JavaScript — the single shared entry, built as `application.js` and loaded on
// every page by the base template. It does almost nothing itself: it detects which page it is
// on and lazily loads the matching module from ./pages/.
//
// ── To add behaviour for a page ────────────────────────────────────────────────────────────
//   1. Create assets/js/pages/<your-page>.js exporting `export function init() { … }`.
//   2. Add one entry to the PAGES list below: a CSS selector that only exists on that page,
//      and a dynamic import of the module.
// The module (and anything it imports) is code-split into its own chunk and only downloaded on
// pages where the hook is present — so heavy dependencies never weigh down unrelated pages.
// Do NOT add <script> tags to templates and do NOT import page modules statically here.
// Shared, reusable helpers belong in assets/js/lib/.

const PAGES = [
  { hook: "#pb-topic-table", load: () => import("./pages/playbook-table.js") },
  { hook: ".pbindex .pbindex-event", load: () => import("./pages/playbook-index.js") },
];

function dispatch() {
  for (const page of PAGES) {
    const hook = document.querySelector(page.hook);
    // Skip if the hook is absent, or already initialised. The dataset marker lives on the (shared)
    // DOM node, so a second dispatch — e.g. application.js evaluated twice from different URLs (a
    // duplicate <script>, a stale cached copy) — is a no-op instead of throwing "Cannot reinitialise
    // DataTable". Marked synchronously, before the async import, so concurrent dispatches can't race.
    if (!hook || hook.dataset.aircInitialized) continue;
    hook.dataset.aircInitialized = "true";
    page
      .load()
      .then((module) => module.init?.())
      .catch((error) => console.error(`[airc] failed to load module for ${page.hook}`, error));
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", dispatch);
} else {
  dispatch();
}
